import { useEffect, useState } from 'react';
import { useCioPlpContext } from './useCioPlpContext';
import useRequestConfigs from './useRequestConfigs';
const useSort = ({ sortOptions }) => {
    const contextValue = useCioPlpContext();
    if (!contextValue) {
        throw new Error('useSort must be used within a component that is a child of <CioPlp />');
    }
    const [selectedSort, setSelectedSort] = useState(null);
    const { getRequestConfigs, setRequestConfigs } = useRequestConfigs();
    const { sortBy, sortOrder } = getRequestConfigs();
    // Read sort configs from url and set state
    useEffect(() => {
        const sortOption = sortOptions.find((option) => option.sortBy === sortBy && option.sortOrder === sortOrder);
        if (sortOption)
            setSelectedSort(sortOption);
        // Select default sort option
        else if (sortOptions.length) {
            const defaultSort = sortOptions.find((option) => option.status === 'selected');
            if (defaultSort)
                setSelectedSort(defaultSort);
        }
    }, [sortBy, sortOrder, sortOptions]);
    const changeSelectedSort = (sortOption) => {
        setSelectedSort(sortOption);
        setRequestConfigs({ sortBy: sortOption.sortBy, sortOrder: sortOption.sortOrder, page: 1 });
    };
    return {
        sortOptions,
        selectedSort,
        changeSelectedSort,
    };
};
export default useSort;
